import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeTab, setActiveTab] = useState('famille');
  const [formData, setFormData] = useState({ nom: '', email: '', profil: '', telephone: '', attente: '' });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [nlEmail, setNlEmail] = useState('');
  const [nlSubmitted, setNlSubmitted] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } }),
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const submitTesteur = (e) => {
    e.preventDefault();
    if (!formData.nom || !formData.email || !formData.profil || !formData.telephone) return;
    fetch('https://script.google.com/macros/s/AKfycbxI6fUdyH3Nf82Ty1wzCfjb6O5YHs7X8XqsoX8GG6n_t3V77fEx4Ia2-vc2NISC8qCeWA/exec', {
      method: 'POST',
      body: JSON.stringify({ nom: formData.nom, email: formData.email, telephone: formData.telephone, profil: formData.profil, message: formData.attente })
    });
    setFormSubmitted(true);
    setTimeout(() => navigate(`/register?nom=${encodeURIComponent(formData.nom)}&email=${encodeURIComponent(formData.email)}&profil=${encodeURIComponent(formData.profil)}&telephone=${encodeURIComponent(formData.telephone)}`), 1500);
  };

  const submitNewsletter = (e) => {
    e.preventDefault();
    if (!nlEmail) return;
    fetch('https://script.google.com/macros/s/AKfycbxI6fUdyH3Nf82Ty1wzCfjb6O5YHs7X8XqsoX8GG6n_t3V77fEx4Ia2-vc2NISC8qCeWA/exec', {
      method: 'POST',
      body: JSON.stringify({ nom: 'Newsletter', email: nlEmail, telephone: '', profil: 'Newsletter', message: '' })
    });
    setNlSubmitted(true);
  };

  return (
    <>
      <style>{`
        :root{--vert:#2D7A5F;--vert-dark:#1A5A42;--vert-light:#D8F0E5;--vert-pale:#F0FAF5;--encre:#141A17;--gris:#6B7280;--gris-light:#F4F6F5;--border:#E2EDE8;--blanc:#FFFFFF}
        .lp *{box-sizing:border-box;margin:0;padding:0}
        .lp{font-family:'DM Sans',sans-serif;font-weight:300;color:var(--encre);background:var(--blanc);line-height:1.7;overflow-x:hidden}
        .lp h1,.lp h2,.lp h3{font-family:'Lora',serif;font-weight:600;line-height:1.2}
        .lp-nav{position:fixed;top:0;left:0;right:0;z-index:100;background:rgba(255,255,255,0.92);backdrop-filter:blur(12px);border-bottom:1px solid var(--border);padding:0 2rem;height:60px;display:flex;align-items:center;justify-content:space-between}
        .lp-nav-logo{font-family:'Lora',serif;font-size:1.3rem;font-weight:600;color:var(--vert);text-decoration:none;letter-spacing:-0.02em}
        .lp-nav-links{display:flex;align-items:center;gap:2rem;list-style:none}
        .lp-nav-links a{font-size:0.85rem;color:var(--gris);text-decoration:none;transition:color 0.2s;font-weight:400;cursor:pointer}
        .lp-nav-links a:hover{color:var(--vert)}
        .lp-nav-cta{background:var(--vert)!important;color:var(--blanc)!important;padding:0.45rem 1.1rem;border-radius:6px;font-weight:500!important;font-size:0.83rem!important;transition:background 0.2s!important}
        .lp-nav-cta:hover{background:var(--vert-dark)!important}
        .lp-nav-btn{background:transparent;color:var(--gris)!important;padding:0.45rem 1.1rem;border:1px solid var(--border);border-radius:6px;font-weight:400!important;font-size:0.83rem!important;cursor:pointer;transition:all 0.2s}
        .lp-nav-btn:hover{border-color:var(--vert);color:var(--vert)!important}
        .lp-hamburger{display:none;flex-direction:column;gap:5px;cursor:pointer;padding:4px;background:none;border:none}
        .lp-hamburger span{width:22px;height:2px;background:var(--encre);border-radius:2px;display:block}
        .lp-hero{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:100px 2rem 60px;background:linear-gradient(160deg,var(--vert-pale) 0%,var(--blanc) 60%);position:relative;overflow:hidden}
        .lp-hero::before{content:'';position:absolute;top:-200px;right:-200px;width:600px;height:600px;border-radius:50%;background:radial-gradient(circle,rgba(45,122,95,0.06) 0%,transparent 70%);pointer-events:none}
        .lp-hero-inner{max-width:760px;text-align:center;position:relative;z-index:1}
        .lp-hero-badge{display:inline-flex;align-items:center;gap:0.5rem;background:var(--vert-light);color:var(--vert-dark);border-radius:20px;padding:0.35rem 1rem;font-size:0.78rem;font-family:'DM Mono',monospace;letter-spacing:0.04em;margin-bottom:2rem}
        .lp-hero-badge::before{content:'';width:6px;height:6px;border-radius:50%;background:var(--vert);animation:lp-pulse 2s infinite;flex-shrink:0}
        @keyframes lp-pulse{0%,100%{opacity:1}50%{opacity:0.4}}
        @keyframes lp-fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        .lp-hero h1{font-size:clamp(2.4rem,5vw,3.8rem);color:var(--encre);margin-bottom:1.2rem;letter-spacing:-0.03em;animation:lp-fadeUp 0.6s ease 0.1s both}
        .lp-hero h1 em{font-style:italic;color:var(--vert)}
        .lp-hero-sub{font-size:1.1rem;color:var(--gris);max-width:520px;margin:0 auto 2.5rem;line-height:1.7;animation:lp-fadeUp 0.6s ease 0.2s both}
        .lp-hero-actions{display:flex;gap:1rem;justify-content:center;flex-wrap:wrap;animation:lp-fadeUp 0.6s ease 0.3s both}
        .lp-hero-note{margin-top:1.5rem;font-size:0.8rem;color:var(--gris);animation:lp-fadeUp 0.6s ease 0.4s both}
        .lp-btn-primary{background:var(--vert);color:var(--blanc);padding:0.85rem 2rem;border-radius:8px;font-size:0.95rem;font-weight:500;text-decoration:none;transition:all 0.2s;border:2px solid var(--vert);display:inline-flex;align-items:center;gap:0.5rem;cursor:pointer}
        .lp-btn-primary:hover{background:var(--vert-dark);border-color:var(--vert-dark);transform:translateY(-1px);box-shadow:0 4px 16px rgba(45,122,95,0.25)}
        .lp-btn-secondary{background:transparent;color:var(--vert);padding:0.85rem 2rem;border-radius:8px;font-size:0.95rem;font-weight:500;text-decoration:none;transition:all 0.2s;border:2px solid var(--border);display:inline-flex;align-items:center;gap:0.5rem;cursor:pointer}
        .lp-btn-secondary:hover{border-color:var(--vert);background:var(--vert-pale)}
        .lp section{padding:80px 2rem}
        .lp-container{max-width:960px;margin:0 auto}
        .lp-section-label{font-family:'DM Mono',monospace;font-size:0.7rem;letter-spacing:0.12em;text-transform:uppercase;color:var(--vert);margin-bottom:0.75rem}
        .lp-section-title{font-size:clamp(1.6rem,3vw,2.2rem);color:var(--encre);margin-bottom:1rem;letter-spacing:-0.02em}
        .lp-section-lead{font-size:1rem;color:var(--gris);max-width:600px;margin-bottom:3rem;line-height:1.7}
        .lp-constat{background:var(--gris-light)}
        .lp-constat-grid{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:var(--border);border-radius:12px;overflow:hidden}
        .lp-constat-item{background:var(--blanc);padding:1.8rem}
        .lp-constat-item .icon{font-size:1.6rem;margin-bottom:0.75rem;display:block}
        .lp-constat-item h3{font-family:'DM Sans',sans-serif;font-size:0.95rem;font-weight:500;color:var(--encre);margin-bottom:0.4rem}
        .lp-constat-item p{font-size:0.88rem;color:var(--gris);line-height:1.6}
        .lp-features-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5rem;margin-top:2rem}
        .lp-feature-card{background:var(--vert-pale);border:1px solid var(--border);border-radius:10px;padding:1.5rem;transition:transform 0.2s,box-shadow 0.2s}
        .lp-feature-card:hover{transform:translateY(-3px);box-shadow:0 8px 24px rgba(45,122,95,0.1)}
        .lp-feature-icon{font-size:1.6rem;margin-bottom:0.75rem;display:block}
        .lp-feature-card h3{font-family:'DM Sans',sans-serif;font-size:0.95rem;font-weight:500;color:var(--vert-dark);margin-bottom:0.4rem}
        .lp-feature-card p{font-size:0.84rem;color:var(--gris);line-height:1.6}
        .lp-tabs-section{background:var(--vert-pale)}
        .lp-tabs-nav{display:flex;gap:0;border:1px solid var(--border);border-radius:8px;overflow:hidden;width:fit-content;margin-bottom:2.5rem}
        .lp-tab-btn{padding:0.65rem 1.8rem;font-size:0.9rem;font-weight:500;border:none;background:var(--blanc);color:var(--gris);cursor:pointer;transition:all 0.2s;font-family:'DM Sans',sans-serif}
        .lp-tab-btn.active{background:var(--vert);color:var(--blanc)}
        .lp-tab-content{display:none}
        .lp-tab-content.active{display:block}
        .lp-tab-inner{display:grid;grid-template-columns:1fr 1fr;gap:3rem;align-items:start}
        .lp-tab-text h3{font-size:1.4rem;margin-bottom:1rem;letter-spacing:-0.02em}
        .lp-tab-text p{color:var(--gris);font-size:0.95rem;margin-bottom:1.5rem;line-height:1.7}
        .lp-tab-list{list-style:none;display:flex;flex-direction:column;gap:0.6rem}
        .lp-tab-list li{display:flex;align-items:flex-start;gap:0.6rem;font-size:0.9rem;color:var(--encre)}
        .lp-tab-list li::before{content:'–';color:var(--vert);font-weight:500;flex-shrink:0;margin-top:0.05em}
        .lp-tab-visual{background:var(--blanc);border:1px solid var(--border);border-radius:12px;padding:2rem;display:flex;flex-direction:column;gap:0.8rem}
        .lp-tab-visual-item{display:flex;align-items:center;gap:0.8rem;padding:0.7rem 1rem;background:var(--vert-pale);border-radius:8px;font-size:0.85rem}
        .lp-prix-cards{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5rem;margin-top:2rem}
        .lp-prix-card{background:var(--blanc);border:1px solid var(--border);border-radius:12px;padding:2rem;position:relative;transition:transform 0.2s,box-shadow 0.2s}
        .lp-prix-card:hover{transform:translateY(-3px);box-shadow:0 8px 24px rgba(0,0,0,0.08)}
        .lp-prix-card.featured{border-color:var(--vert);background:var(--vert-pale)}
        .lp-badge-featured{position:absolute;top:-12px;left:50%;transform:translateX(-50%);background:var(--vert);color:var(--blanc);font-size:0.72rem;font-family:'DM Mono',monospace;letter-spacing:0.06em;padding:0.2rem 0.8rem;border-radius:20px;white-space:nowrap}
        .lp-prix-card .target{font-size:0.78rem;font-family:'DM Mono',monospace;color:var(--vert);letter-spacing:0.06em;text-transform:uppercase;margin-bottom:0.5rem}
        .lp-prix-card h3{font-family:'DM Sans',sans-serif;font-size:1rem;font-weight:500;margin-bottom:1rem;color:var(--encre)}
        .lp-prix-amount{font-size:2.4rem;font-weight:600;color:var(--vert);font-family:'Lora',serif;line-height:1;margin-bottom:0.2rem}
        .lp-prix-period{font-size:0.8rem;color:var(--gris);margin-bottom:1.5rem}
        .lp-prix-features{list-style:none;display:flex;flex-direction:column;gap:0.5rem;margin-bottom:1.5rem}
        .lp-prix-features li{font-size:0.85rem;color:var(--gris);display:flex;align-items:flex-start;gap:0.5rem}
        .lp-prix-features li::before{content:'✓';color:var(--vert);font-weight:500;flex-shrink:0}
        .lp-degressi{background:var(--gris-light)}
        .lp-degressi-track{display:flex;gap:0;margin:2rem 0;border-radius:10px;overflow:hidden;border:1px solid var(--border)}
        .lp-degressi-step{flex:1;padding:1.2rem 1rem;text-align:center;background:var(--blanc);border-right:1px solid var(--border);transition:background 0.2s}
        .lp-degressi-step:last-child{border-right:none}
        .lp-degressi-step:hover{background:var(--vert-pale)}
        .lp-degressi-users{font-family:'DM Mono',monospace;font-size:0.68rem;color:var(--gris);letter-spacing:0.06em;margin-bottom:0.3rem}
        .lp-degressi-prix{font-size:1.4rem;font-weight:600;color:var(--vert);font-family:'Lora',serif}
        .lp-degressi-label{font-size:0.72rem;color:var(--gris);margin-top:0.2rem}
        .lp-asso-box{background:var(--blanc);border:1px solid var(--border);border-radius:10px;padding:1.5rem 2rem;margin-top:1.5rem;display:flex;align-items:flex-start;gap:1.2rem}
        .lp-asso-icon{font-size:1.8rem;flex-shrink:0}
        .lp-asso-box h4{font-family:'DM Sans',sans-serif;font-size:0.95rem;font-weight:500;margin-bottom:0.3rem}
        .lp-asso-box p{font-size:0.85rem;color:var(--gris);line-height:1.6}
        .lp-transparence-grid{display:grid;grid-template-columns:1fr 1fr;gap:2rem;align-items:start}
        .lp-transp-stat{text-align:center;padding:1.5rem;background:var(--vert-pale);border-radius:10px;border:1px solid var(--border)}
        .lp-transp-stat .number{font-family:'Lora',serif;font-size:2.4rem;font-weight:600;color:var(--vert);line-height:1;margin-bottom:0.3rem}
        .lp-transp-stat .label{font-size:0.82rem;color:var(--gris)}
        .lp-transp-stats-grid{display:grid;grid-template-columns:1fr 1fr;gap:1rem;margin-top:1.5rem}
        .lp-transp-engagements{list-style:none;display:flex;flex-direction:column;gap:0.6rem}
        .lp-transp-engagements li{display:flex;gap:0.6rem;font-size:0.88rem;color:var(--encre);padding:0.7rem 0.9rem;background:var(--vert-pale);border-radius:6px;border-left:3px solid var(--vert)}
        .lp-testeurs{background:var(--vert);color:var(--blanc)}
        .lp-testeurs .lp-section-label{color:rgba(255,255,255,0.6)}
        .lp-testeurs .lp-section-title{color:var(--blanc)}
        .lp-testeurs .lp-section-lead{color:rgba(255,255,255,0.8)}
        .lp-testeurs-grid{display:grid;grid-template-columns:1fr 1fr;gap:3rem;align-items:start}
        .lp-testeur-conditions{background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.2);border-radius:10px;padding:1.5rem}
        .lp-testeur-conditions h4{font-family:'DM Mono',monospace;letter-spacing:0.06em;text-transform:uppercase;font-size:0.72rem;color:rgba(255,255,255,0.7);margin-bottom:0.75rem;font-weight:400}
        .lp-testeur-conditions ul{list-style:none;display:flex;flex-direction:column;gap:0.5rem}
        .lp-testeur-conditions li{font-size:0.88rem;color:rgba(255,255,255,0.85);display:flex;gap:0.5rem}
        .lp-testeur-conditions li::before{content:'→';flex-shrink:0;opacity:0.6}
        .lp-testeurs-form{display:flex;flex-direction:column;gap:1rem}
        .lp-form-group{display:flex;flex-direction:column;gap:0.4rem}
        .lp-form-group label{font-size:0.8rem;color:rgba(255,255,255,0.7);font-family:'DM Mono',monospace;letter-spacing:0.04em}
        .lp-form-group input,.lp-form-group select{padding:0.75rem 1rem;border-radius:7px;border:1px solid rgba(255,255,255,0.25);background:rgba(255,255,255,0.1);color:var(--blanc);font-size:0.9rem;font-family:'DM Sans',sans-serif;outline:none;transition:border-color 0.2s}
        .lp-form-group input::placeholder{color:rgba(255,255,255,0.4)}
        .lp-form-group input:focus,.lp-form-group select:focus{border-color:rgba(255,255,255,0.6)}
        .lp-form-group select option{background:var(--vert-dark);color:var(--blanc)}
        .lp-form-submit{background:var(--blanc);color:var(--vert-dark);padding:0.85rem;border-radius:8px;border:none;font-size:0.95rem;font-weight:500;cursor:pointer;font-family:'DM Sans',sans-serif;transition:all 0.2s;margin-top:0.5rem;width:100%}
        .lp-form-submit:hover{background:var(--vert-light);transform:translateY(-1px)}
        .lp-form-note{font-size:0.75rem;color:rgba(255,255,255,0.5);text-align:center}
        .lp-newsletter{background:var(--gris-light);padding:60px 2rem}
        .lp-newsletter-inner{max-width:600px;margin:0 auto;text-align:center}
        .lp-newsletter h2{font-size:1.6rem;margin-bottom:0.75rem;letter-spacing:-0.02em}
        .lp-newsletter p{color:var(--gris);font-size:0.95rem;margin-bottom:1.5rem}
        .lp-newsletter-form{display:flex;gap:0.75rem;max-width:440px;margin:0 auto}
        .lp-newsletter-form input{flex:1;padding:0.75rem 1rem;border:1px solid var(--border);border-radius:7px;font-size:0.9rem;font-family:'DM Sans',sans-serif;outline:none;background:var(--blanc)}
        .lp-newsletter-form button{background:var(--vert);color:var(--blanc);padding:0.75rem 1.4rem;border:none;border-radius:7px;font-size:0.9rem;font-weight:500;cursor:pointer;font-family:'DM Sans',sans-serif;white-space:nowrap}
        .lp-newsletter-form button:hover{background:var(--vert-dark)}
        .lp-footer{padding:2.5rem 2rem;border-top:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:1rem}
        .lp-footer-logo{font-family:'Lora',serif;font-size:1.1rem;font-weight:600;color:var(--vert)}
        .lp-footer-links{display:flex;gap:1.5rem;list-style:none}
        .lp-footer-links a{font-size:0.82rem;color:var(--gris);text-decoration:none}
        .lp-footer-links a:hover{color:var(--vert)}
        .lp-footer-note{font-size:0.78rem;color:var(--gris);font-family:'DM Mono',monospace}
        .reveal{opacity:0;transform:translateY(24px);transition:opacity 0.6s ease,transform 0.6s ease}
        .reveal.visible{opacity:1;transform:translateY(0)}
        @media(max-width:768px){
          .lp-nav-links{display:none}
          .lp-nav-links.open{display:flex;flex-direction:column;position:fixed;top:60px;left:0;right:0;background:var(--blanc);border-bottom:1px solid var(--border);padding:1.5rem 2rem;gap:1.2rem;z-index:99}
          .lp-hamburger{display:flex}
          .lp-constat-grid,.lp-features-grid,.lp-prix-cards,.lp-transparence-grid,.lp-testeurs-grid,.lp-tab-inner{grid-template-columns:1fr}
          .lp-degressi-track{flex-wrap:wrap}
          .lp-degressi-step{flex:calc(50% - 0.5px);border-right:1px solid var(--border)}
          .lp-degressi-step:nth-child(even){border-right:none}
          .lp-newsletter-form{flex-direction:column}
          .lp-footer{flex-direction:column;align-items:flex-start;gap:1.2rem}
        }
      `}</style>

      <div className="lp">
        {/* Nav */}
        <nav className="lp-nav">
          <span className="lp-nav-logo">Passerelle</span>
          <ul className={`lp-nav-links${menuOpen ? ' open' : ''}`} id="navLinks">
            <li><a href="#comment-ca-marche" onClick={() => setMenuOpen(false)}>Comment ça marche</a></li>
            <li><a href="#parents" onClick={() => setMenuOpen(false)}>Parents & aidants</a></li>
            <li><a href="#pros" onClick={() => setMenuOpen(false)}>Professionnels</a></li>
            <li><a href="#testeurs" onClick={() => setMenuOpen(false)} className="lp-nav-cta">Devenir testeur</a></li>
            <li><button className="lp-nav-btn" onClick={() => navigate('/login')}>Connexion</button></li>
          </ul>
          <button className="lp-hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span /><span /><span />
          </button>
        </nav>

        {/* Hero */}
        <section className="lp-hero">
          <div className="lp-hero-inner">
            <div className="lp-hero-badge">Lancement en cours · 50 testeurs recherchés</div>
            <h1>Coordonner les soins.<br /><em>Simplifier le quotidien.</em></h1>
            <p className="lp-hero-sub">Passerelle réunit parents, patients, aidants et professionnels de santé en un espace commun — pour que plus rien ne se perde entre les intervenants.</p>
            <div className="lp-hero-actions">
              <a href="#testeurs" className="lp-btn-primary">Devenir testeur gratuit →</a>
              <a href="#comment-ca-marche" className="lp-btn-secondary">En savoir plus</a>
            </div>
            <p className="lp-hero-note">Gratuit pour les 50 premiers testeurs · Sans engagement</p>
          </div>
        </section>

        {/* Constat */}
        <section className="lp-constat" id="comment-ca-marche">
          <div className="lp-container">
            <div className="reveal">
              <p className="lp-section-label">Le constat</p>
              <h2 className="lp-section-title">Ce qu'on a tous vécu</h2>
              <p className="lp-section-lead">Quand un parcours de soins implique plusieurs professionnels, c'est toujours la famille qui fait le lien. À la main. Sans outil.</p>
            </div>
            <div className="lp-constat-grid reveal">
              <div className="lp-constat-item"><span className="icon">🔄</span><h3>Réexpliquer à chaque rendez-vous</h3><p>Chaque nouveau professionnel repart de zéro. Le contexte se perd, le temps se gaspille, la famille s'épuise.</p></div>
              <div className="lp-constat-item"><span className="icon">📋</span><h3>Le dossier MDPH, une montagne</h3><p>Des documents éparpillés, des délais imprévisibles, des pièces à rassembler à chaque renouvellement.</p></div>
              <div className="lp-constat-item"><span className="icon">🔕</span><h3>Les intervenants ne se parlent pas</h3><p>L'orthophoniste ne sait pas ce que le psychomotricien a observé. L'information reste en silo.</p></div>
              <div className="lp-constat-item"><span className="icon">🗂️</span><h3>Aucun espace commun n'existe</h3><p>Ni Mon Espace Santé, ni Doctolib ne sont pensés pour ça. Passerelle comble ce vide.</p></div>
            </div>
          </div>
        </section>

        {/* Fonctionnalités */}
        <section id="fonctionnalites">
          <div className="lp-container">
            <div className="reveal">
              <p className="lp-section-label">La plateforme</p>
              <h2 className="lp-section-title">Un espace pour tout le monde</h2>
              <p className="lp-section-lead">Passerelle s'adapte à qui vous êtes — parent, patient, aidant ou professionnel. Chacun voit ce qu'il doit voir.</p>
            </div>
            <div className="lp-features-grid reveal">
              {[
                { icon: '📁', title: 'Le dossier partagé', desc: 'Informations, documents, bilans — tout au même endroit. Accessible à qui vous choisissez.' },
                { icon: '📅', title: 'Le planning coordonné', desc: 'Vos rendez-vous, ceux des professionnels, le tout dans un calendrier lisible.' },
                { icon: '💬', title: 'La messagerie sécurisée', desc: 'Échangez directement avec chaque intervenant. Ce qui est dit est tracé, accessible.' },
                { icon: '📝', title: 'Les comptes-rendus', desc: 'Chaque professionnel rédige ses CR et choisit ce qu\'il partage — famille, autres pros.' },
                { icon: '😊', title: 'Le suivi quotidien', desc: 'Humeur, observations, notes du quotidien — une mémoire vivante pour les professionnels.' },
                { icon: '🗂️', title: 'Le dossier MDPH assisté', desc: 'Documents centralisés, historique complet. Le dossier se constitue au fil du temps.' },
              ].map(({ icon, title, desc }) => (
                <div key={title} className="lp-feature-card">
                  <span className="lp-feature-icon">{icon}</span>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Tabs */}
        <section className="lp-tabs-section" id="parents">
          <div className="lp-container">
            <div className="reveal">
              <p className="lp-section-label">Deux univers, une plateforme</p>
              <h2 className="lp-section-title">Fait pour vous — vraiment</h2>
              <p className="lp-section-lead">Que vous soyez parent, patient, aidant ou professionnel de santé, Passerelle vous offre un espace pensé pour votre réalité.</p>
            </div>
            <div className="lp-tabs-nav reveal">
              <button className={`lp-tab-btn${activeTab === 'famille' ? ' active' : ''}`} onClick={() => setActiveTab('famille')}>Familles & aidants</button>
              <button className={`lp-tab-btn${activeTab === 'pro' ? ' active' : ''}`} onClick={() => setActiveTab('pro')}>Professionnels</button>
            </div>
            <div className={`lp-tab-content${activeTab === 'famille' ? ' active' : ''}`}>
              <div className="lp-tab-inner">
                <div className="lp-tab-text">
                  <h3>Votre enfant, votre proche — enfin suivi comme il le mérite.</h3>
                  <p>Vous êtes au cœur du parcours. Passerelle vous donne un espace pour centraliser, partager et suivre sans tout porter seul.</p>
                  <ul className="lp-tab-list">
                    <li>Un dossier complet pour votre enfant ou proche, partagé avec les professionnels que vous choisissez</li>
                    <li>Le planning de tous les rendez-vous en un seul endroit</li>
                    <li>La messagerie directe avec chaque intervenant</li>
                    <li>Les documents importants accessibles à tout moment</li>
                    <li>Le suivi quotidien de l'humeur et des observations</li>
                    <li>Un dossier MDPH qui se constitue au fil du temps</li>
                  </ul>
                </div>
                <div className="lp-tab-visual">
                  {[
                    { icon: '📁', text: 'Dossier enfant centralisé' },
                    { icon: '📅', text: 'Planning coordonné' },
                    { icon: '💬', text: 'Messagerie avec les pros' },
                    { icon: '📄', text: 'Documents partagés' },
                    { icon: '😊', text: 'Suivi quotidien' },
                  ].map(({ icon, text }) => (
                    <div key={text} className="lp-tab-visual-item">
                      <span className="vi-icon">{icon}</span>
                      <span className="vi-text">{text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className={`lp-tab-content${activeTab === 'pro' ? ' active' : ''}`} id="pros">
              <div className="lp-tab-inner">
                <div className="lp-tab-text">
                  <h3>Moins d'administratif. Plus de temps pour vos patients.</h3>
                  <p>Passerelle centralise vos fiches patients, vos plannings et vos échanges avec les familles — sans remplacer vos outils actuels.</p>
                  <ul className="lp-tab-list">
                    <li>Fiches patients complètes avec historique partagé</li>
                    <li>Planning et gestion des séances</li>
                    <li>Comptes-rendus rédigés et partagés en un clic</li>
                    <li>Messagerie sécurisée avec familles et collègues</li>
                    <li>Devis, contrats et facturation intégrés</li>
                    <li>Facturation électronique (à venir — réforme Sept. 2026)</li>
                  </ul>
                </div>
                <div className="lp-tab-visual">
                  {[
                    { icon: '👥', text: 'Fiches patients' },
                    { icon: '📅', text: 'Gestion des séances' },
                    { icon: '📝', text: 'Comptes-rendus partagés' },
                    { icon: '💶', text: 'Facturation intégrée' },
                    { icon: '🔒', text: 'Données sécurisées' },
                  ].map(({ icon, text }) => (
                    <div key={text} className="lp-tab-visual-item">
                      <span className="vi-icon">{icon}</span>
                      <span className="vi-text">{text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testeurs */}
        <section className="lp-testeurs" id="testeurs">
          <div className="lp-container">
            <div className="reveal">
              <p className="lp-section-label">Rejoindre l'aventure</p>
              <h2 className="lp-section-title">50 testeurs. Gratuit.<br />Une place dans l'histoire.</h2>
              <p className="lp-section-lead">Vous ne serez pas juste un utilisateur. Vous serez les premières personnes à façonner Passerelle.</p>
            </div>
            <div className="lp-testeurs-grid reveal">
              <div>
                <div className="lp-testeur-conditions" style={{ marginBottom: '1.5rem' }}>
                  <h4>Ce qu'on vous demande</h4>
                  <ul>
                    <li>Utiliser Passerelle dans votre quotidien réel</li>
                    <li>Nous donner vos retours — même sévères</li>
                    <li>Une assiduité minimale (statut testeur révocable sinon)</li>
                    <li>Parler de Passerelle si ça vous semble utile</li>
                  </ul>
                </div>
                <div className="lp-testeur-conditions">
                  <h4>Ce qu'on vous offre</h4>
                  <ul>
                    <li>Accès gratuit complet pendant la phase test</li>
                    <li>Accès prioritaire aux nouvelles fonctionnalités</li>
                    <li>Votre voix dans les décisions produit</li>
                    <li>Tarif testeur maintenu si vous restez</li>
                  </ul>
                </div>
              </div>
              <div>
                {formSubmitted ? (
                  <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '8px', padding: '2rem', textAlign: 'center', fontSize: '0.95rem', color: 'white' }}>
                    ✓ Demande reçue ! Anne vous contactera dans les 48h. Merci de rejoindre l'aventure.
                  </div>
                ) : (
                  <form className="lp-testeurs-form" onSubmit={submitTesteur}>
                    <div className="lp-form-group"><label>Prénom et nom</label><input type="text" placeholder="Marie Dupont" value={formData.nom} onChange={e => setFormData({ ...formData, nom: e.target.value })} /></div>
                    <div className="lp-form-group"><label>Email</label><input type="email" placeholder="marie@exemple.fr" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} /></div>
                    <div className="lp-form-group">
                      <label>Je suis</label>
                      <select value={formData.profil} onChange={e => setFormData({ ...formData, profil: e.target.value })}>
                        <option value="">Choisissez votre profil</option>
                        <option>Parent d'un enfant en parcours complexe</option>
                        <option>Patient</option>
                        <option>Aidant (proche, famille)</option>
                        <option>Orthophoniste</option>
                        <option>Psychomotricien</option>
                        <option>Éducateur spécialisé</option>
                        <option>Kinésithérapeute</option>
                        <option>Psychologue</option>
                        <option>Autre professionnel de santé</option>
                      </select>
                    </div>
                    <div className="lp-form-group"><label>Téléphone *</label><input type="text" placeholder="06 00 00 00 00" value={formData.telephone} onChange={e => setFormData({ ...formData, telephone: e.target.value })} required /></div>
                    <div className="lp-form-group"><label>Ce que vous attendez de Passerelle (optionnel)</label><input type="text" placeholder="Ex. : centraliser les échanges, simplifier le planning..." value={formData.attente} onChange={e => setFormData({ ...formData, attente: e.target.value })} /></div>
                    <p className="lp-form-note" style={{ fontSize: '0.75rem', opacity: 0.85 }}>Merci de ne pas indiquer d'information médicale dans ce formulaire.</p>
                    <button type="submit" className="lp-form-submit">Je veux être testeur →</button>
                    <p className="lp-form-note">Gratuit pour les 50 premiers · Vous parlerez à Anne, pas à un bot.</p>
                    <p className="lp-form-note" style={{ fontSize: '0.72rem', opacity: 0.8 }}>En envoyant ce formulaire, vous acceptez que Passerelle utilise ces informations pour vous recontacter dans le cadre de la phase de test. <a href="/politique-confidentialite" style={{ color: 'inherit', textDecoration: 'underline' }}>Politique de confidentialité</a></p>
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <section className="lp-newsletter">
          <div className="lp-newsletter-inner reveal">
            <p className="lp-section-label" style={{ textAlign: 'center' }}>Rester informé</p>
            <h2>Suivre l'avancement de Passerelle</h2>
            <p>On publie nos avancées, nos chiffres, nos prochaines fonctionnalités. Pas de spam — juste l'essentiel, quand il se passe quelque chose.</p>
            {nlSubmitted ? (
              <p style={{ marginTop: '1rem', fontSize: '0.85rem', color: 'var(--vert-dark)' }}>✓ Vous êtes inscrit — bienvenue dans la communauté Passerelle.</p>
            ) : (
              <form className="lp-newsletter-form" onSubmit={submitNewsletter}>
                <input type="email" placeholder="votre@email.fr" value={nlEmail} onChange={e => setNlEmail(e.target.value)} />
                <button type="submit">S'abonner</button>
              </form>
            )}
            {!nlSubmitted && (
              <p style={{ marginTop: '0.5rem', fontSize: '0.72rem', color: '#636e72' }}>Votre email ne sert qu'à la newsletter — désinscription à tout moment. <a href="/politique-confidentialite" style={{ color: 'inherit', textDecoration: 'underline' }}>Politique de confidentialité</a></p>
            )}
          </div>
        </section>

        {/* Footer */}
        <footer className="lp-footer">
          <div className="lp-footer-logo">Passerelle</div>
          <ul className="lp-footer-links">
            <li><a href="mailto:anne@mypasserelle.com">Contact</a></li>
            <li><a href="/mentions-legales">Mentions légales</a></li>
            <li><a href="/politique-confidentialite">Politique de confidentialité</a></li>
          </ul>
          <div className="lp-footer-note">SASU · Nancy · 2026 · anne@mypasserelle.com</div>
        </footer>
      </div>
    </>
  );
};

export default LandingPage;